
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/vero",
      function () {
        return require("private-next-pages/destinations/vero.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/vero"])
      });
    }
  